import { createRouter, createWebHistory } from 'vue-router';

import { adminRoutes, allAfterLoginRoutes, protectedRoutes, publicRoutes, readonlyRoutes, routes } from './routes';
import { RoutePaths } from './types/routePaths';
import { UserService } from '../api/user/userService';
import { useUserStore } from '../stores/userStore/userStore';
import { useUserTokensStore } from '../stores/userTokensStore/userTokensStore';
import { UserRole } from '@common/contracts';

const updateUser = async () => {
  const userStore = useUserStore();

  try {
    const freshUser = await UserService.getMe();

    if (freshUser) {
      userStore.setUser(freshUser);
    } else {
      userStore.removeUser();
    }
  } catch (err) {
    console.error('Error getting user', err);
  }
};

const shouldUpdateUser = () => {
  return Math.random() < 0.5;
};

export const router = createRouter({
  history: createWebHistory(),
  routes,
  //to, from, savedPosition
  scrollBehavior() {
    // always scroll to top
    setTimeout(() => {
      return { top: 0 };
    }, 100);
  },
});

router.beforeEach(async (to, _, next) => {
  const userStore = useUserStore();
  const existingUser = userStore.getLoggedInUser;

  if ((!existingUser || to.matched.some((record) => protectedRoutes.includes(record.path))) && shouldUpdateUser()) {
    await updateUser();
  }

  const isAdmin = userStore.getLoggedInUserRole === UserRole.admin;
  const isGuest = userStore.getLoggedInUserRole === UserRole.guest;
  const userTokensStore = useUserTokensStore();
  const isAuthenticated = userTokensStore.getLoggedInUserTokens?.accessToken;

  if (to.path === RoutePaths.resetPassword) {
    next();
    return;
  }

  if (isAuthenticated && isGuest && to.matched.some((record) => readonlyRoutes.includes(record.path))) {
    next();
    return;
  }

  if (isAuthenticated && isAdmin && to.matched.some((record) => allAfterLoginRoutes.includes(record.path))) {
    next();
    return;
  }

  if (isAuthenticated && !isGuest && to.matched.some((record) => protectedRoutes.includes(record.path))) {
    next();
    return;
  }

  if (isAuthenticated && isGuest) {
    next({
      path: RoutePaths.pictures,
    });
    return;
  }

  if (isAuthenticated) {
    next({
      path: RoutePaths.dashboard,
    });
    return;
  }

  if (publicRoutes.includes(to.path)) {
    next();
    return;
  }

  if (!isAuthenticated && !isAdmin && to.matched.some((record) => adminRoutes.includes(record.path))) {
    next(RoutePaths.root);
    return;
  }

  next(RoutePaths.login);
});
